// This icon file is generated automatically.
var PWalletOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zM12.12 8H7.25V6h4.88v2zm0 4.13H1.88V1.87h10.25V5H6.75a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h5.38v3.13zM8.07 7a.62.62 0 101.25 0 .62.62 0 00-1.25 0z", "fill-rule": "nonzero" } }] }, "name": "p-wallet", "theme": "outlined" };
export default PWalletOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PWalletOutlined.js
// module id = 3737
// module chunks = 0